// extracted by mini-css-extract-plugin
export var aircallIframe = "_lb-3";
export var fabContainer = "_lb-5";
export var fabRinging = "_lb-6";
export var loadingOverlay = "_lb-4";
export var pulse = "_lb-7";
export var widgetContent = "_lb-2";
export var widgetPanel = "_lb-0";
export var widgetPanelExpanded = "_lb-1";